import { createEvent, sample } from 'effector'
import { VacancyResource } from 'api/endpoints/openapi-generated.schemas'
import { interviewLocalStorageKey } from 'utils/interview'
import { lazyUpd } from './effector.utils'
import { interviewFixturesService } from '../../interview-fixtures.service'

class InterviewIdSaveService {
  private readonly loadInterviewId = createEvent<string | null>()
  private readonly readLocalStorage = createEvent<VacancyResource>()
  private readonly writeToLocalStorage =
    createEvent<[VacancyResource, string]>()

  constructor() {
    interviewFixturesService.$interviewId.on(this.loadInterviewId, lazyUpd)
    this.initLocalStorageLogic()
  }

  private initLocalStorageLogic = (): void => {
    if (typeof window === 'undefined') return

    this.readLocalStorage.watch((vacancy) => {
      const interviewId = localStorage.getItem(
        interviewLocalStorageKey(vacancy.id)
      )
      if (interviewId) this.loadInterviewId(interviewId)
    })

    sample({
      clock: interviewFixturesService.$vacancy,
      filter: Boolean,
      target: this.readLocalStorage
    })

    this.writeToLocalStorage.watch(([vacancy, interviewId]) => {
      localStorage.setItem(interviewLocalStorageKey(vacancy.id), interviewId)
    })

    sample({
      clock: interviewFixturesService.setInterviewId,
      source: interviewFixturesService.$vacancy,
      filter: Boolean,
      fn: (a, b): [VacancyResource, string] => [a, b],
      target: this.writeToLocalStorage
    })
  }

  subscribe = (): VoidFunction => {
    return () => void 0
  }
}

export const interviewIdSaveService = new InterviewIdSaveService()
